import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeNetService {

  constructor(private http: HttpClient) { }

  // authorize-net.service.tsAdd commentMore actions
  updatePaymentStatus(data: any) {
    return this.http.patch(`${environment.apiUrl}/authorize-net/update-status`, data);
  }
}
